import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Button, FormGroup, Label, Input, FormFeedback, DropdownItem } from 'reactstrap';
import AutoCompleteAddress from './AutoCompleteAddress';
import InputMask from 'react-input-mask';
import withMaskedInput from '../../HOC/withMaskedInput';
import FormSelect from '../FormSelect/FormSelect';
import {isMobile} from 'react-device-detect';

import './Address.scss';

class AddressFields extends Component {
  constructor(props) {
    super(props);

    this.provinces = [
      {value: "AB", name: "Alberta"},
      {value: "BC", name: "British Columbia"},
      {value: "MB", name: "Manitoba"},
      {value: "NB", name: "New Brunswick"},
      {value: "NL", name: "Newfoundland and Labrador"},
      {value: "NS", name: "Nova Scotia"},
      {value: "ON", name: "Ontario"},
      {value: "PE", name: "Prince Edward Island"},
      {value: "QC", name: "Quebec"},
      {value: "SK", name: "Saskatchewan"},
      {value: "NT", name: "Northwest Territories"},
      {value: "NU", name: "Nunavut"},
      {value: "YT", name: "Yukon"}
    ];

    let manualEntry = this.props.manualEntry || false;

    this.state = {
      manualEntry: manualEntry,
      sameAsMyAddress: false,
      autoFocus: this.props.autoFocus
    }
    
    if(manualEntry !== false) {
      this.props.setManualEntry(manualEntry);
    }


    this.toggleManualEntry = this.toggleManualEntry.bind(this);
    this.toggleSameAsMyAddress = this.toggleSameAsMyAddress.bind(this);
    this.populateAddressFields = this.populateAddressFields.bind(this);
    this.handleChange = this.handleChange.bind(this);
  }
  componentDidUpdate(prevProps) {
    if(prevProps.manualEntry !== this.props.manualEntry) {      
      this.setState({
        manualEntry: this.props.manualEntry
      });
    }
  }
  handleChange(event) {    
    this.props.resetSameAsMyAddress();
    this.props.handleChange(event);
  }
  toggleManualEntry(event, triggerAutofocus) {
    this.setState({
      manualEntry: !this.state.manualEntry,
      autoFocus: triggerAutofocus === undefined ? this.state.autoFocus : triggerAutofocus
    }, () => {
      this.props.setManualEntry(this.state.manualEntry);
    });
  }
  toggleSameAsMyAddress(event) {
    event.preventDefault();
    this.props.toggleSameAsMyAddress(!this.props.sameAsMyAddress);
  }
  populateAddressFields(addressFields) {
    this.props.resetSameAsMyAddress();
    this.props.populateAddressFields(addressFields);
  }
  formGroupId(fieldName) {
    if(fieldName === "homeAddress") {
      return (this.props.authUserIndex !== null && this.props.autocompleteValidation[fieldName].isInvalid ? `auth-user-${this.props.authUserIndex}-invalid` : null);
    }
    else {
      return (this.props.authUserIndex !== null && this.props.validation[fieldName].isInvalid ? `auth-user-${this.props.authUserIndex}-invalid` : null);
    }
  }
  onFocus(event) {
    event.preventDefault();
    event.target.setSelectionRange(event.target.value.length, event.target.value.length);
  }
  render() { 
    let addressForm;
    let sameAsMyAddress;

    if(this.props.toggleSameAsMyAddress !== undefined) {
      sameAsMyAddress = (
        <FormGroup check onClick={this.toggleSameAsMyAddress}>
          <Input id="same-as-my-address" type="checkbox" name="sameAsMyAddress" checked={this.props.sameAsMyAddress} readOnly/>
          <Label for="same-as-my-address" check>Same as my address</Label>
        </FormGroup>);
    }
    if(this.state.manualEntry) {
      addressForm = (<div>
        <FormGroup id={this.formGroupId("address1")}>
          <Label for="address1"><div className="label">Address Line 1</div><Button color="link" onClick={this.toggleManualEntry}>Look up address</Button></Label>
          <Input name="address1" value={this.props.address1} onChange={this.handleChange} onFocus={this.onFocus} id="address1" onBlur={this.props.validateField} invalid={this.props.validation.address1.isInvalid} maxLength="35" autoFocus={this.state.autoFocus} autoComplete="address-line1" autoCapitalize="words" autoCorrect="off" />
          <FormFeedback>{this.props.validation.address1.message}</FormFeedback>
          {sameAsMyAddress}
        </FormGroup>
        <FormGroup id={this.formGroupId("address2")}>
          <Label for="address2">Address Line 2</Label>
          <Input name="address2" value={this.props.address2} onChange={this.handleChange} id="address2" onBlur={this.props.validateField} invalid={this.props.validation.address2.isInvalid} maxLength="35" autoComplete="address-line2" autoCapitalize="words" autoCorrect="off" />
          <FormFeedback>{this.props.validation.address2.message}</FormFeedback>
        </FormGroup>      
        <FormGroup id={this.formGroupId("city")}>
          <Label for="city">City</Label>
          <Input name="city" value={this.props.city} onChange={this.handleChange} id="city" onBlur={this.props.validateField} invalid={this.props.validation.city.isInvalid} maxLength="20" autoComplete="address-level2" autoCapitalize="words" autoCorrect="off" />
          <FormFeedback>{this.props.validation.city.message}</FormFeedback>
        </FormGroup>  
        <FormGroup id={this.formGroupId("province")}>
          <Label for="province">Province</Label>
          {isMobile ? 
            <Input type="select" name="province" id="province" value={this.props.province} onChange={this.handleChange} onBlur={this.props.validateField} invalid={this.props.validation.province.isInvalid}> 
              {this.provinces.map(province => {
                return (<option key={province.value} value={province.value}>{province.name}</option>)
              })}
            </Input>
          :
            <FormSelect name="province" handleChange={this.handleChange} validateField={this.props.validateField} value={this.props.province} label={this.provinces.find(province => province.value === this.props.province).name} isInvalid={this.props.validation.province.isInvalid}>
              {this.provinces.map(province => {
                return (<DropdownItem key={province.value} value={province.value}>{province.name}</DropdownItem>
              )})}
            </FormSelect>
          }
          <FormFeedback>{this.props.validation.province.message}</FormFeedback>
        </FormGroup> 
        <FormGroup id={this.formGroupId("postalCode")}>
          <Label for="postalCode">Postal Code</Label>
          <InputMask mask="a9a 9a9" value={this.props.postalCode} onKeyDown={this.props.onKeyDown} onSelect={this.props.onClick} onClick={this.props.onClick} beforeMaskedValueChange={this.props.beforeMaskedValueChange} onChange={this.handleChange} onBlur={this.props.validateField} invalid={this.props.validation.postalCode.isInvalid}>
            {(inputProps) => <Input name="postalCode" {...inputProps} id="postalCode" autoComplete="postal-code" autoCapitalize="characters" autoCorrect="off" />}
          </InputMask>
          <FormFeedback>{this.props.validation.postalCode.message}</FormFeedback>
        </FormGroup>    
      </div>);
    }
    else {
      addressForm = (<div>            
        <FormGroup id={this.formGroupId("homeAddress")}>
          <Label for="homeAddress"><div className="label">{this.props.label}</div><Button color="link" onClick={this.toggleManualEntry}>Enter address manually</Button></Label>
          <AutoCompleteAddress 
            onChange={this.populateAddressFields} 
            toggleManualEntry={this.toggleManualEntry} 
            invalid={this.props.autocompleteValidation.homeAddress.isInvalid}
            handleChange={this.props.handleChange}
            autoFocus={this.props.autoFocus} />
          <FormFeedback>{this.props.autocompleteValidation.homeAddress.message}</FormFeedback>
          {sameAsMyAddress}
        </FormGroup>
      </div>);
    }
    return (
      <div className="address">  
        {addressForm}
      </div>
    );
  }
}

AddressFields.defaultProps= {  
  address1: "",
  address2: "",
  city: "",
  province: "BC",
  postalCode: "" ,
  sameAsMyAddress: false,
  populateAddressFields: () => {},
  setManualEntry: () => {},
  resetSameAsMyAddress: () => {},
  validation: {
    homeAddress: {
      isInvalid: false,
      message: ""
    },
    address1: {
      isInvalid: false,
      message: ""
    },
    address2: {
      isInvalid: false,
      message: ""
    },
    city: {
      isInvalid: false,
      message: ""
    },
    province: {
      isInvalid: false,
      message: ""
    },
    postalCode: {
      isInvalid: false,
      message: ""
    }
  },
  autocompleteValidation: {
    homeAddress: {
      isInvalid: false,
      message: ""
    }
  },
  autoFocus: false,
  authUserIndex: null,
  label: "Home Address"
};

AddressFields.propTypes = {
  address1: PropTypes.string,
  address2: PropTypes.string,
  city: PropTypes.string,
  province: PropTypes.string,
  postalCode: PropTypes.string,
  populateAddressFields: PropTypes.func,
  setManualEntry: PropTypes.func,
  autoFocus: PropTypes.bool,
  authUserIndex: PropTypes.number,
  label: PropTypes.string
};

export default withMaskedInput("postalCode")(AddressFields);


// WEBPACK FOOTER //
// ./src/components/Address/AddressFields.js